import {CalculatorName} from "../../calculations/model/Calculator";
import {TriggeredBy} from "../../manual_import/model/TriggeredBy";
import {ImportSource} from "../../manual_import/model/ImportSource";
import {DirectMailerStatus} from "../../action_status/model/ActionStatus";

export enum EntitiesSortingOrder {
    NEW_FIRST = 'NEW_FIRST',

    OLD_FIRST = 'OLD_FIRST'
}

export interface SortableFilter {
    sortingOrder?: EntitiesSortingOrder;
}

export interface EntitiesFilter {
    startDate?: Date;
    endDate?: Date;
    customerName?: string;
    employees?: number[];
    isSuccess?: boolean;
    branchNames: string[];
    brandName: string[];
}


export interface ImportReportLogFilter extends EntitiesFilter, SortableFilter {

    triggeredBy?: TriggeredBy;
    importSource?: ImportSource[];
    fetchPersistedCustomers?: boolean;
    fetchRunning?: boolean;

}

export interface OpportunityFilterUi extends EntitiesFilter, SortableFilter {
    calculatorNames: CalculatorName[];
    groupByCustomer?: boolean,
    groupByCalculator?: boolean
    importTypes: string[];
}

export interface DirectMailerLogFilterUi extends  OpportunityFilterUi {
    status: DirectMailerStatus;
    showMode: MailDemonstration;
}

export enum MailDemonstration {
    SHOW_SENT = 'Show sent',
    SHOW_UNSENT = 'Show unsent'
}